import Loader from '@jpi-cloud-web-pro/jpi-cloud-shared/components/common/Loader';
import React, { PropsWithChildren, Suspense } from 'react';
import { HeroConfigSetter } from './HeroContext';
import * as Styled from './HeroWrapper.style';

export type HeroConfig = {
  noHero?: boolean;
  noHeading?: boolean;
  isBrandedPage?: boolean;
  // Alternative names for backward compatibility
  isHiddenHero?: boolean;
  isHiddenHeroSystem?: boolean;
};

type HeroWrapperProps = {
  heroConfig?: HeroConfig;
};

export const HeroWrapper: React.FC<PropsWithChildren<HeroWrapperProps>> = ({ heroConfig = {}, children }) => {
  return (
    <HeroConfigSetter config={heroConfig}>
      <Suspense fallback={<Loader dark isPage />}>
        <Styled.ContainerFluid>{children}</Styled.ContainerFluid>
      </Suspense>
    </HeroConfigSetter>
  );
};

export default HeroWrapper;
